import {HtmlTemplates} from "./html-templates";
import logger from "./logger";

export const Loader = (function () {

	async function injectStyle() {
		const style = await HtmlTemplates.getTemplate(HtmlTemplates.loaderStyle);
		if (!document.getElementById('loader-style')) {
			const styleTag = document.createElement('style');
			styleTag.id = 'loader-style';
			styleTag.textContent = await style;
			document.head.appendChild(styleTag);
		}
	}

	const show = async (targetSelector) => {
		const target = document.querySelector(targetSelector);
		if (!target) {
			logger.warn(`Loader target "${targetSelector}" not found.`);
			return;
		}

		injectStyle().then(r => {
		});

		if (target.querySelector('.loader-inline')) return;

		const loaderHTML = await HtmlTemplates.getTemplate(HtmlTemplates.loaderHTML, true);
		const wrapper = document.createElement('div');
		wrapper.innerHTML = await loaderHTML;
		target.appendChild(wrapper.firstElementChild);
	};

	const hide = (targetSelector) => {
		const target = document.querySelector(targetSelector);
		if (!target) return;
		const loader = target.querySelector('.loader-inline');
		if (loader) loader.remove();
	};

	return {show, hide};
})();
